if (!customElements.get('delivery-estimate')) {
  customElements.define('delivery-estimate', class DeliveryEstimate extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('[data-de-input]');
      this.submitButton = this.querySelector('[data-de-submit]');
      this.submitLabel = this.querySelector('[data-de-submit-label]');
      this.errorEl = this.querySelector('[data-de-error]');
      this.inputRow = this.querySelector('[data-de-input-row]');
      this.resultEl = this.querySelector('[data-de-result]');
      this.dateEl = this.querySelector('[data-de-date]');
      this.deliverToEl = this.querySelector('[data-de-deliver-to]');
      this.changeButton = this.querySelector('[data-de-change]');

      this.onSubmit = this.onSubmit.bind(this);
      this.onChange = this.onChange.bind(this);

      this.submitButton.addEventListener('click', this.onSubmit);
      this.changeButton.addEventListener('click', this.onChange);
      this.input.addEventListener('input', () => {
        this.input.value = this.input.value.replace(/\D/g, '').slice(0, 6);
        this.hideError();
      });
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') this.onSubmit();
      });
    }

    hideError() {
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
    }

    showError(message) {
      this.errorEl.textContent = message;
      this.errorEl.hidden = false;
    }

    setChecking(checking) {
      this.submitButton.disabled = checking;
      this.submitLabel.textContent = checking ? '…' : 'Check';
    }

    async onSubmit() {
      const pincode = this.input.value.trim();

      if (!/^\d{6}$/.test(pincode)) {
        this.showError('Enter a 6-digit pincode.');
        return;
      }

      this.hideError();
      this.setChecking(true);

      try {
        const response = await fetch(`${this.dataset.apiUrl}?pincode=${encodeURIComponent(pincode)}`);
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || 'request failed');
        }

        if (!data.serviceable) {
          this.showError("Sorry, we don't deliver to this location.");
          return;
        }

        this.renderResult(data, pincode);
      } catch (error) {
        this.showError('Could not check delivery estimate. Please try again.');
      } finally {
        this.setChecking(false);
      }
    }

    renderResult(data, pincode) {
      const date = new Date(data.estimatedDeliveryDate);
      const formatted = date.toLocaleDateString('en-IN', { weekday: 'long' })
        + ', ' + date.getDate() + ' ' + date.toLocaleDateString('en-IN', { month: 'short' });

      this.dateEl.textContent = formatted;
      this.deliverToEl.textContent = `Deliver to ${data.city ? data.city + ' · ' : ''}${pincode}`;

      this.inputRow.hidden = true;
      this.resultEl.hidden = false;
    }

    onChange() {
      this.resultEl.hidden = true;
      this.inputRow.hidden = false;
      this.input.value = '';
      this.input.focus();
    }
  });
}
